module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/16.fb4320e4.jpg";